import { AST } from '@handlebars/parser';
import { NodeType } from '../../node/types';
import { DEFAULT_LOCATION as loc } from '../../source/location';

export const createContentStatement = (value: string): AST.ContentStatement => ({
  type: NodeType.ContentStatement,
  value,
  original: { close: false, open: false },
  loc,
});
